<template>
  <b-modal v-model="show" :title="$t('config.productCategory.title')" :no-close-on-esc="true"
           :no-close-on-backdrop="true">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <div class="form-group">
              <label>Категория <span class="red">*</span></label>
              <v-select v-model="productCategory.parent" label="name"
                        :options="categories"
                        :filterable="false"
                        @search="onCategorySearch"
                        @search:focus="onCategoryFocus">
                <template slot="option" slot-scope="option" v-if="option">
                  <div v-html="option.name"></div>
                </template>
                <template slot="selected-option"
                          v-if="productCategory && productCategory.parent && productCategory.parent.text">
                  <div v-html="productCategory.parent.text"
                       @click="$eventBus.$emit('search:focus')"></div>
                </template>
                <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
              </v-select>
            </div>

          </div>
          <div class="form-group">
            <label>Номи <span class="red">*</span></label>
            <input
                type="text"
                class="form-control"
                v-model="productCategory.name"
                :class="{'is-invalid': $v.productCategory.name.$error}"
                @blur="$v.productCategory.name.$touch()"
            />
            <div class="red" v-if="$v.productCategory.name.$error">Номи</div>
          </div>
        </div>
      </div>
    </div>
    <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
      <button class="all-btn add-btn float-right" @click="save">
        Сақлаш
      </button>
      <button class="all-btn delete-btn float-right mr-2" @click="cancel">
        Бекор қилиш
      </button>
    </div>
  </b-modal>
</template>

<script>
import bModal from 'bootstrap-vue/es/components/modal/modal'
import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
import {clone} from '@/shared/utils';
import {required} from 'vuelidate/lib/validators'
import initFilterModel from '@/shared/filter';

export default {
  name: "ProductSubCategoryAddView",
  components: {
    'b-modal': bModal
  },
  directives: {
    'b-modal': bModalDirective
  },
  data() {
    return {
      show: false,
      processing: false,
      categoryFilter: initFilterModel(),
      productCategory: {
        id: null,
        name: '',
        parent: {
          id: null
        }
      },
      categories: []
    }
  },
  validations: {
    productCategory: {
      name: {
        required: required
      }
    }
  },
  methods: {
    cancel() {
      this.show = false;
    },
    initData() {
      this.processing = true;

      if (!this.productCategory.id) {
        return;
      }

      const vm = this;

      this.$http.get('product-sub-category-plus/' + this.productCategory.id).then(res => {
        vm.processing = false;
        vm.productCategory = res.data;
      }, err => {
        vm.processing = false;
        console.log(err);
      });
    },
    save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      const vm = this;
      this.processing = true;

      this.$http.post('product-sub-category-plus/save', this.productCategory)
          .then(res => {
            vm.processing = false;
            const response = res.data;
            if (response.statusCode === 'OK') {
              vm.show = false;
              this.$eventBus.$emit('productPlusSubCategoryChanged', response);
            } else {
              this.$swal({
                title: this.$t('messages.common.warning'),
                text: response.message,
                type: 'warning'
              });
            }
          }, err => {
            vm.processing = false;
            console.log(err);
          });
    },
    onCategorySearch(searchTxt, loading) {
      loading(true);
      this.categories = [];
      this.categoryFilter.search = searchTxt;
      this.$http.post('product-category-plus/search', this.categoryFilter).then(res => {
        this.categories = res.data.data;
        loading(false);
      }, err => {
        console.log(err);
      });
    },
    onCategoryFocus() {
      this.categories = [];
      this.categoryFilter.search = '';
      this.$http.post('product-category-plus/search', this.categoryFilter).then(res => {
        this.categories = res.data.data;
      }, err => {
        console.log(err);
      });
    }
  },
  created() {
    this.initData()
    this.$eventBus.$on('showProductPlusSubCategoryModal', (data) => {
      if (data) {
        this.productCategory = clone(data);
      } else {
        this.productCategory = {}
      }
      this.show = true;
    });
  }
}
</script>

<style scoped>

</style>